"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { Tooltip } from "react-tooltip";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
interface WaveDropActionsOpenProps {
  readonly drop: ExtendedDrop;
}
const WaveDropActionsOpen: React.FC<WaveDropActionsOpenProps> = t0 => {
  const $ = _c(18);
  const {
    drop
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const canBeOpened = drop.drop_type !== ApiDropType.Chat;
  let t1;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t1 = drop_0 => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("drop", drop_0.id);
      router.push(`${pathname}?${params.toString()}`);
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onDropClick = t1;
  if (!canBeOpened) {
    return null;
  }
  let t2;
  if ($[4] !== drop || $[5] !== onDropClick) {
    t2 = () => onDropClick(drop);
    $[4] = drop;
    $[5] = onDropClick;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = `open-${drop.id}`;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-transition tw-ease-out tw-duration-300" xmlns="http://www.w3.org/2000/svg"><path d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3) {
    t5 = <button className="tw-text-iron-400 tw-px-2 desktop-hover:hover:tw-text-iron-50 tw-h-full tw-group tw-bg-transparent tw-rounded-full tw-border-0 tw-flex tw-items-center tw-gap-x-2 tw-text-[0.8125rem] tw-leading-5 tw-font-medium tw-transition tw-ease-out tw-duration-300" onClick={t2} aria-label="Open drop" data-tooltip-id={t3}>{t4}</button>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `open-${drop.id}`;
  let t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px",
      zIndex: 10
    };
    t8 = <span className="tw-text-xs">Open</span>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6) {
    t9 = <Tooltip id={t6} place="top" style={t7}>{t8}</Tooltip>;
    $[13] = t6;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t5 || $[16] !== t9) {
    t10 = <>{t5}{t9}</>;
    $[15] = t5;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
export default WaveDropActionsOpen;